import { CALL_API } from '../middleware/ApiMiddleware';

export const CONTACT_CUSTOM_FIELDS_FETCH_REQUEST = 'CONTACT_CUSTOM_FIELDS_FETCH_REQUEST';
export const CONTACT_CUSTOM_FIELDS_FETCH_SUCCESS = 'CONTACT_CUSTOM_FIELDS_FETCH_SUCCESS';
export const CONTACT_CUSTOM_FIELDS_FETCH_FAILURE = 'CONTACT_CUSTOM_FIELDS_FETCH_FAILURE';

export const CONTACT_CUSTOM_FIELD_CREATE_REQUEST = 'CONTACT_CUSTOM_FIELD_CREATE_REQUEST';
export const CONTACT_CUSTOM_FIELD_CREATE_SUCCESS = 'CONTACT_CUSTOM_FIELD_CREATE_SUCCESS';
export const CONTACT_CUSTOM_FIELD_CREATE_FAILURE = 'CONTACT_CUSTOM_FIELD_CREATE_FAILURE';

export const CONTACT_CUSTOM_FIELD_EDIT_REQUEST = 'CONTACT_CUSTOM_FIELD_EDIT_REQUEST';
export const CONTACT_CUSTOM_FIELD_EDIT_SUCCESS = 'CONTACT_CUSTOM_FIELD_EDIT_SUCCESS';
export const CONTACT_CUSTOM_FIELD_EDIT_FAILURE = 'CONTACT_CUSTOM_FIELD_EDIT_FAILURE';

export const CONTACT_CUSTOM_FIELD_FETCH_REQUEST = 'CONTACT_CUSTOM_FIELD_FETCH_REQUEST';
export const CONTACT_CUSTOM_FIELD_FETCH_SUCCESS = 'CONTACT_CUSTOM_FIELD_FETCH_SUCCESS';
export const CONTACT_CUSTOM_FIELD_FETCH_FAILURE = 'CONTACT_CUSTOM_FIELD_FETCH_FAILURE';

export const CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST = 'CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST';
export const CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS = 'CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS';
export const CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE = 'CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE';

const baseURL = 'config/contact-custom-fields';

export const fetchContactCustomFields = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [
      CONTACT_CUSTOM_FIELDS_FETCH_REQUEST,
      CONTACT_CUSTOM_FIELDS_FETCH_SUCCESS,
      CONTACT_CUSTOM_FIELDS_FETCH_FAILURE,
    ],
  },
});

export const createContactCustomField = (newContactCustomFieldRequest: IContactCustomFieldRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: newContactCustomFieldRequest,
    authenticated: true,
    types: [
      CONTACT_CUSTOM_FIELD_CREATE_REQUEST,
      CONTACT_CUSTOM_FIELD_CREATE_SUCCESS,
      CONTACT_CUSTOM_FIELD_CREATE_FAILURE,
    ],
  },
});

export const editContactCustomField = (
  contactCustomFieldId: number,
  newContactCustomFieldRequest: IContactCustomFieldRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${contactCustomFieldId}`,
    method: 'put',
    body: newContactCustomFieldRequest,
    authenticated: true,
    types: [CONTACT_CUSTOM_FIELD_EDIT_REQUEST, CONTACT_CUSTOM_FIELD_EDIT_SUCCESS, CONTACT_CUSTOM_FIELD_EDIT_FAILURE],
  },
});

export const fetchContactCustomField = (contactCustomFieldId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${contactCustomFieldId}`,
    method: 'get',
    authenticated: true,
    types: [CONTACT_CUSTOM_FIELD_FETCH_REQUEST, CONTACT_CUSTOM_FIELD_FETCH_SUCCESS, CONTACT_CUSTOM_FIELD_FETCH_FAILURE],
  },
});

export const editContactCustomFieldSequence = (sequence: number[], contactType: ContactType) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    params: {
      contactType,
    },
    body: { sequence },
    authenticated: true,
    types: [
      CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST,
      CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS,
      CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE,
    ],
  },
});
